<!-- Show spinner while loading -->
@if (isLoading()) {
  <div class="spinner-container">
    <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
  </div>
}

<!-- Show list when not loading -->
@if (!isLoading() && !noLabels()) {
  <mat-list>
    @for (label of labels(); track label) {
      <mat-list-item>
        <mat-checkbox
          (change)="onCheckboxChange($event, label)">
          {{ label.name }}
        </mat-checkbox>
      </mat-list-item>
    }
  </mat-list>
} @else {
  @if (!isLoading()) {
    <p>לא נמצאו תוויות</p>
  }
}

